export const lskWorks = {
  movie: [
    {
      id: 1,
      title: '쉐어 더 비전',
      year: '2011',
      image: require('./movie/1. 쉐어 더 비전.jpg')
    },
    {
      id: 2,
      title: '트라이앵글', 
      year: '2009',
      image: require('./movie/2. 트라이앵글.jpeg')
    },
    {
      id: 3,
      title: '로맨틱 아일랜드',
      year: '2008',
      image: require('./movie/3. 로맨틱 아일랜드.jpeg')
    },
    {
      id: 4,
      title: '가면',
      year: '2007',
      image: require('./movie/4. 가면.jpeg')
    },
    {
      id: 5,
      title: '타짜',
      year: '2006',
      image: require('./movie/5. 타짜.jpeg')
    },
  ],
  drama: [
    {
      id: 16,
      title: '심우면 연리리',
      year: '2026',
      image: require('./drama/simumyeon-yeolliri.webp')
    },
    {
      id: 17,
      title: '개소리',
      year: '2024',
      image: require('./drama/dog-knows-everything.webp')
    },
    {
      id: 1,
      title: '왼손잡이 아내',
      year: '2019',
      image: require('./drama/1. 왼손잡이 아내.jpg')
    },
    {
      id: 2,
      title: '팩 투더 퓨처',
      year: '2018',
      image: require('./drama/2. 팩 투더 퓨처.jpg')
    },
    {
      id: 3,
      title: '아버님 제가 모실게요',
      year: '2016',
      image: require('./drama/3. 아버님 제가 모실게요.jpg')
    },
    {
      id: 4,
      title: '마이 리틀 베이비',
      year: '2016',
      image: require('./drama/4. 마이 리틀 베이비.jpg')
    },
    {
      id: 5,
      title: '딱 너같은 딸',
      year: '2015',
      image: require('./drama/5. 딱 너같은 딸.png')
    },
    {
      id: 6,
      title: '식샤를 합시다',
      year: '2013',
      image: require('./drama/6.식샤를 합시다.jpeg')
    },
    {
      id: 7,
      title: '금 나와라 뚝딱!',
      year: '2013',
      // eslint-disable-next-line import/no-webpack-loader-syntax
      image: require('./drama/7. 금 나와라 뚝딱.jpg')
    },
    {
      id: 8,
      title: '컬러 오브 우먼',
      year: '2011',
      image: require('./drama/8. 컬러 오브 우먼.jpg')
    },
    {
      id: 9,
      title: '대물',
      year: '2010',
      image: require('./drama/9. 대물.jpg')
    },
    {
      id: 10,
      title: '국가가 부른다',
      year: '2010',
      image: require('./drama/10. 국가가 부른다.jpg')
    },
    {
      id: 11,
      title: '천만번 사랑해',
      year: '2009',
      image: require('./drama/11. 천만번 사랑해.png')
    },
    {
      id: 12,
      title: '대한민국 변호사',
      year: '2008',
      image: require('./drama/12. 대한민국 변호사.jpg')
    },
    {
      id: 13,
      title: '며느리 전성시대',
      year: '2007',
      image: require('./drama/13. 며느리 전성시대.jpg')
    },
    {
      id: 14,
      title: '소울메이트',
      year: '2006',
      image: require('./drama/14. 소울메이트.jpg')
    },
    {
      id: 15,
      title: '하늘이시여',
      year: '2005',
      image: require('./drama/15. 하늘이시여.webp')
    },
  ],
}
